<template>
  <div class="bg-white">
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <form class="p-4 d-flex flex-wrap justify-content-center" @submit.prevent="submitForm">
          <div class="container my-4">
            <h1>{{ $t('message.myAccount') }}</h1>
          </div>
          <my-detail ref="myDetail" :edit-model="detailModel" />
          <delivery-address ref="deliveryAddress" :edit-model="deliveryAddressModel" class="mt-4" />
          <cards :dbuser="dbuser" />
          <div
            v-if="success"
            class="alert alert-primary p-4 mt-4 alert-color w-100"
            role="alert"
          >{{ $t('message.profileSavedSuccessfully') }}</div>
          <div
            v-if="hasError"
            class="alert alert-danger p-4 mt-4 alert-color w-100"
            role="alert"
          >{{ hasError }}</div>
          <div class="w-50" style="margin-top:4rem">
            <button
              :disabled="loading"
              type="submit"
              class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-center align-items-center"
              :style="desktopStyles.btn"
            >
              {{ $t('message.saveChanges') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryAddress from "./DeliveryAddress";

import MyDetail from "./MyDetail";
import cards from "./cards";
import { mapGetters, mapActions } from "vuex";
import { getDBUser } from "../../api/services/userService.js";
import shared from "../../sharedscripts/user/profile.js";
export default {
  components: {
    DeliveryAddress,
    MyDetail,
    cards
  },
  data() {
    return {
      deliveryAddressModel: {
        type: Object,
        default: () => {
          "";
        }
      },
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: ""
      },
      dbuser: {},
      hasError: "",
      success: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["user", "desktopStyles"])
  },
  watch: {
    user() {
      let that = this;
      if (this.user) {
        getDBUser(this.user.id).onSnapshot(
          function(doc) {
            if (doc.exists) {
              that.dbuser = doc.data();
              that.initModel();
            }
          },
          function(reason) {
            that.insertErrorlog([
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath
            ]);
            that.redirectToErrorPage();
          }
        );
      }
    }
  },
  mounted() {
    this.setStoreLoaded();
    let that = this;
    if (this.user) {
      getDBUser(this.user.id).onSnapshot(
        function(doc) {
          if (doc.exists) {
            that.dbuser = doc.data();
            that.initModel();
          }
        },
        function(reason) {
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          ]);
          that.redirectToErrorPage();
        }
      );
    }
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    ...shared.methods
  }
};
</script>
